// extracted by mini-css-extract-plugin
export default {"container":"style_container__geudv","header":"style_header__xcY7t","searchWrapper":"style_searchWrapper__vbX0-","content":"style_content__ll0a4","actions":"style_actions__RP--6"};